import React from 'react';
import Icon from '../../../components/AppIcon';

const GlobalCounter = ({ count }) => {
  const formatTurkishNumber = (num) => {
    return num?.toLocaleString('tr-TR');
  };

  return (
    <div className="mt-8 md:mt-10 lg:mt-12 pt-6 md:pt-8 lg:pt-10 border-t border-border">
      <div className="flex items-center justify-center gap-3 md:gap-4">
        <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-xl bg-accent/10 flex items-center justify-center flex-shrink-0">
          <Icon name="Car" size={24} color="var(--color-accent)" />
        </div>
        <div className="text-center">
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground mb-1">
            Bugün
          </p>
          <p className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-primary">
            {formatTurkishNumber(count)}
          </p>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground mt-1">
            araç bu QR'ı okuttu
          </p>
        </div>
      </div>

      {/* Instagram message */}
      <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-3 px-4 text-center">
        <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
          Türkiye'nin ilk interaktif araç kokusu projesi <span className="font-semibold text-primary">TRAFİK KONYA</span>'ya aittir. Trafikkonya'nın Instagram hesabını takip etmeyi unutma.
        </p>
        <a
          href="https://www.instagram.com/trafikkonya"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-4 py-2 rounded-full text-white text-sm font-semibold flex-shrink-0 transition-opacity hover:opacity-90"
          style={{ background: 'linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)' }}
        >
          <Icon name="Instagram" size={16} color="white" />
          Instagram
        </a>
      </div>
    </div>
  );
};

export default GlobalCounter;